import React from 'react';
import { GridFilterPanel } from '@mui/x-data-grid';
import { motion, useDragControls } from 'framer-motion';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import { Box } from '@mui/material';

const DraggableFilterPanel = (props: React.ComponentProps<typeof GridFilterPanel>) => {
    const dragControls = useDragControls();

    return (
        <motion.div
            drag
            dragControls={dragControls}
            dragListener={false}
            dragMomentum={false}
            style={{
                zIndex: 1400,
                position: 'absolute',
                top: 0,
                left: 0,
                backgroundColor: '#fff',
                borderRadius: '12px',
                boxShadow: '0 12px 24px -4px rgba(145, 158, 171, 0.12), 0 0 2px 0 rgba(145, 158, 171, 0.2)',
                border: '1px solid rgba(145, 158, 171, 0.2)',
                display: 'flex',
                flexDirection: 'row',
                overflow: 'hidden',
                minWidth: 'max-content'
            }}
        >
            <Box
                onPointerDown={(event) => dragControls.start(event)}
                sx={{
                    cursor: 'grab',
                    '&:active': { cursor: 'grabbing' },
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    px: 0.5,
                    backgroundColor: '#f4f6f8',
                    borderRight: '1px solid rgba(145, 158, 171, 0.2)',
                    color: '#637381',
                    transition: 'all 0.2s',
                    '&:hover': {
                        color: '#212b36',
                        backgroundColor: 'rgba(145, 158, 171, 0.16)',
                    }
                }}
            >
                <DragIndicatorIcon fontSize="small" />
            </Box>
            <Box sx={{ flex: 1 }}>
                <GridFilterPanel {...props} />
            </Box>
        </motion.div>
    );
};

export default DraggableFilterPanel;
